/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom, DOCUMENT, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, HttpClient } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { IconSetService } from '@coreui/icons-angular';
import { environment } from './environments/environment';

// ===== SHELL mengawal setting (corak sama niise-shell kaunter) =====
// Kod app (interceptor WSO, auth.guard, dll) dalam FESM niise-public-modules baca window.__env
// pada module-load. Hantar setting environment.ts SHELL -> window.__env DAHULU, kemudian
// DYNAMIC import modules (static import di-hoist dan akan muat FESM sebelum baris ini).
// version-env.js/app-env.js (envsubst deploy) yang set nilai sebenar MENANG; jika tiada /
// placeholder "${...}" -> guna environment.ts shell (dev: production=false -> interceptor
// lulus tanpa token, fail i18n transloco /assets/i18n boleh dimuat).
const __w = window as any;
__w.__env = __w.__env || {};
if (__w.__env.PRODUCTION == null || String(__w.__env.PRODUCTION).charAt(0) === '$') {
  __w.__env.PRODUCTION = String(environment.production);
}
if (__w.__env.BYPASS_AUTH == null || String(__w.__env.BYPASS_AUTH).charAt(0) === '$') {
  __w.__env.BYPASS_AUTH = String(environment.localDevBypassAuth);
}

(window as any).DOCUMENT = DOCUMENT;

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// FEV2: teras app dari pustaka niise-public-modules (shell = bootstrapper nipis)
import('niise-public-modules').then(({ AppComponent, appConfig, childRoutes }) => {

// FEV2: daftar route leaf modul awam (di shell) — di depan childRoutes teras
(childRoutes as any).unshift({ path: 'perkhidmatan', loadComponent: () => import('niise-public-ppa').then((m) => m.ServicesHomeComponent) });
(childRoutes as any).unshift({ path: 'stk', loadChildren: () => import('niise-public-stk').then((m) => m.niisePublicStkRoutes) });
(childRoutes as any).unshift({ path: 'esd', loadChildren: () => import('niise-public-esd').then((m) => m.niisePublicEsdRoutes) });
(childRoutes as any).unshift({ path: 'ppa', loadChildren: () => import('niise-public-ppa').then((m) => m.niisePublicPpaRoutes) });
(childRoutes as any).unshift({ path: 'vpp', loadChildren: () => import('niise-public-vpp').then((m) => m.niisePublicVppRoutes) });
(childRoutes as any).unshift({ path: 'hsl', loadChildren: () => import('niise-public-hsl').then((m) => m.niisePublicHslRoutes) });
(childRoutes as any).unshift({ path: 'ptd', loadChildren: () => import('niise-public-ptd').then((m) => m.niisePublicPtdRoutes) });

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    ...appConfig.providers,

    IconSetService,
    provideHttpClient(),
    provideClientHydration(withEventReplay()),

    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'ms',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    )
  ]
}).catch(err => console.error(err));
});
